import { z } from 'zod';

export const RegisterRevisionPlanBodySchema = z.object({
  name: z.string().trim().min(1).max(255),
  genericProductIds: z.array(z.uuid()).min(1),
});

export const RegisterRevisionPlanResponseSchema = z.object({
  revisionPlanId: z.uuid(),
});

export type RegisterRevisionPlanBody = z.infer<typeof RegisterRevisionPlanBodySchema>;
export type RegisterRevisionPlanResponse = z.infer<typeof RegisterRevisionPlanResponseSchema>;
